
import { SimulationConfig, Ball, EscapeRing, Vector2D, ShapeType, MorphData } from '@/types';
import { drawAdvancedBall } from './BallDrawer';
import { ShapeUtils } from '@/logic/physics/ShapeUtils';

export const drawBackground = (
  ctx: CanvasRenderingContext2D,
  width: number,
  height: number,
  config: SimulationConfig
) => {
  if (config.darkMode) {
    ctx.fillStyle = (config.rgbLighting && config.useContainerRGB) ? '#050505' : (config.outerColor === '#f5f5dc' ? '#0a0a0a' : config.outerColor);
  } else {
    ctx.fillStyle = config.outerColor;
  }
  ctx.fillRect(0, 0, width, height);
};

export const drawContainer = (
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  config: SimulationConfig,
  globalHue: number,
  dynamicRadius: number,
  morph?: MorphData
) => {
  const isEscape = config.mode === 'ESCAPE';
  const useRGB = config.rgbLighting && config.useContainerRGB;
  const radius = dynamicRadius || config.containerRadius;
  const shape = morph ? morph.from : (config.containerShape || 'CIRCLE');
  const targetShape = morph ? morph.to : shape;
  const t = morph ? morph.factor : 0;
  const rotRad = (config.containerRotation || 0) * Math.PI / 180;
  
  if (!isEscape || config.escapeShowOuterBorders) {
    for (let i = 0; i < config.numOuterBorders; i++) {
      ctx.beginPath(); 
      if (shape === 'CIRCLE' && targetShape === 'CIRCLE') {
          ctx.arc(centerX, centerY, radius + i * 8, 0, Math.PI * 2);
      } else {
          ctx.save();
          ctx.translate(centerX, centerY);
          ctx.rotate(rotRad);
          ShapeUtils.traceInterpolatedShape(ctx, {x: 0, y: 0}, shape, targetShape, t, radius + i * 8, morph?.baseRadius);
          ctx.restore();
      }
      ctx.strokeStyle = useRGB ? `hsl(${(globalHue + i * 20) % 360}, 100%, 50%)` : config.borderColor;
      ctx.lineWidth = config.containerLineWidth; 
      ctx.lineJoin = 'round';
      ctx.stroke();
    }
  }

  if (!isEscape) {
    ctx.beginPath();
    if (shape === 'CIRCLE' && targetShape === 'CIRCLE') {
        ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
    } else {
        ctx.save();
        ctx.translate(centerX, centerY);
        ctx.rotate(rotRad);
        ShapeUtils.traceInterpolatedShape(ctx, {x: 0, y: 0}, shape, targetShape, t, radius, morph?.baseRadius);
        ctx.restore();
    }
    if (config.darkMode) {
      ctx.fillStyle = useRGB ? '#0a0a0a' : (config.innerColor === '#ffffff' ? '#111' : config.innerColor);
    } else {
      ctx.fillStyle = config.innerColor;
    }
    ctx.fill();
  }
};

export const drawOutsideCollider = (
  ctx: CanvasRenderingContext2D,
  config: SimulationConfig
) => {
  if (!config.outsideColliderEnabled) return;
  
  const halfWidth = (config.outsideColliderWidth * config.outsideColliderScale) / 2;
  const halfHeight = (config.outsideColliderHeight * config.outsideColliderScale) / 2;
  const centerX = (config.outsideColliderOffsetX || 0);
  const centerY = (config.outsideColliderOffsetY || 0);
  
  ctx.beginPath();
  ctx.rect(centerX - halfWidth, centerY - halfHeight, halfWidth * 2, halfHeight * 2);
  ctx.strokeStyle = '#ffffff';
  ctx.lineWidth = 1;
  ctx.stroke();
};

export const drawBall = (
  ctx: CanvasRenderingContext2D,
  b: Ball,
  config: SimulationConfig,
  rgb: string
) => {
  drawAdvancedBall(ctx, b, config, rgb);
};
